'use client';

import '@ui5/webcomponents/dist/Avatar.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * An image-like component that has different display options for representing images and icons in different shapes and sizes, depending on the use case. The shape can be circular or square. There are several predefined sizes, as well as an option to set a custom size.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Avatar)
 */
const Avatar = withWebComponent('ui5-avatar', ['accessibleName', 'colorScheme', 'fallbackIcon', 'icon', 'initials', 'shape', 'size'], ['disabled', 'interactive'], ['badge'], []);
Avatar.displayName = 'Avatar';
export { Avatar };